import apiClient from "@/app/api/client";
import { plantsEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreatePlantRequest,
	Plant,
	PlantListParams,
	PlantPaginatedResponse,
	SuccessResponse,
	UpdatePlantRequest,
} from "../types";

export const plantsService = {
	async list(params: PlantListParams): Promise<PlantPaginatedResponse> {
		const response = await apiClient.get<PlantPaginatedResponse>(plantsEndpoints.list, { params });
		return response.data;
	},

	async getById(id: string): Promise<Plant> {
		const url = replaceParams(plantsEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<Plant>>(url);
		return response.data.data;
	},

	async create(data: CreatePlantRequest): Promise<Plant> {
		const response = await apiClient.post<SuccessResponse<Plant>>(plantsEndpoints.create, data);
		return response.data.data;
	},

	async update(id: string, data: UpdatePlantRequest): Promise<Plant> {
		const url = replaceParams(plantsEndpoints.update, { id });
		const response = await apiClient.put<SuccessResponse<Plant>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(plantsEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
